<template>
  <v-dialog 
    :value="dialog" 
    persistent 
    max-width="800px">
    <v-card>
      <v-form 
        v-if="item && item.type == 'htmlblock'"
        ref="form"
        v-model="valid"              
        lazy-validation>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>
            <span class="headline">Add html/text</span>
          </v-toolbar-title>
        </v-toolbar>           
        <v-card-text>
          <ckeditor 
            :editor="editor" 
            v-model="item.html" 
            :config="editorConfig"/>
          <v-container grid-list-md>
            <v-flex xs12>
              <v-radio-group 
                v-model="item.show"
                persistent-hint
                hint="Should the element be displayed always or when editing a form"
                row 
              >
                <v-radio
                  :value="true"
                  label="Show always"                      
                  color="primary" 
                />
                <v-radio
                  :value="false"
                  label="Show in form"                      
                  color="primary" 
                />
              </v-radio-group>  
            </v-flex>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="primary" 
            flat 
            @click.native="close">Close</v-btn>
          <v-btn 
            v-if="htmlitem.html" 
            color="red darken-1" 
            flat 
            @click.native="remove()">Delete</v-btn>         
          <v-btn 
            color="primary" 
            flat 
            @click.native="save(item)">{{ (htmlitem.html ? 'Update' : 'Save') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FirestoreUploadAdapter } from "@/plugins/FirestoreUploadAdapter";

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = loader => {
    return new FirestoreUploadAdapter(loader);
  };
}

export default {
  name: "Htmlblock",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    htmlitem: {
      type: Object,
      default: null
    },
    selected: {
      type: Number,
      default: null
    }
  },
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      valid: true,
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        mediaEmbed: {
          previewsInData: true
        }
      },
      item: null
    };
  },
  watch: {
    htmlitem: function(val) {
      console.log("val:", val);
      this.item = JSON.parse(JSON.stringify(val));
      console.log("this.item:", this.item);
    }
  },
  methods: {
    save(item) {
      if (this.$refs.form.validate()) {
        this.$emit("statusDialog", false);
        this.$emit("saveItem", item);
        this.$store.dispatch("setLoading", true);
      }
    },
    remove() {
      this.$emit("statusDialog", false);
      this.$emit("saveItem", null);
      this.$store.dispatch("setLoading", true);
    },
    close() {
      this.$emit("statusDialog", false);
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "warning",
        text: "Input not saved"
      });
    }
  }
};
</script>
